import 'css-chunksrc/client/scenes/projectPopup/loader/styles.scss';export default {
  "loader": "_loader_1fgvu_1",
  "header": "_header_1fgvu_5",
  "dates": "_dates_1fgvu_14",
  "group": "_group_1fgvu_25",
  "name": "_name_1fgvu_34",
  "label": "_label_1fgvu_39",
  "subTitle": "_subTitle_1fgvu_46",
  "description": "_description_1fgvu_52",
  "text": "_text_1fgvu_63",
  "row": "_row_1fgvu_68",
  "date": "_date_1fgvu_14",
  "tags": "_tags_1fgvu_82",
  "tag": "_tag_1fgvu_82"
};